/**
 * OWNER CONTROLS' two confirmations, desktop chrome.
 * `design/GT Crew.dc.html` — the transfer and delete modals.
 *
 * The bodies are shared with the phone column (`components/OwnerConfirm.tsx`);
 * this file is the Modal wrapper and the desktop's measurements. The subhead
 * names the crew, which the phone's does not — a real difference between the
 * two mirrors, kept.
 */

import { useQd } from '../../store/index.ts';
import { DeleteCrewBody, TransferBody } from '../../components/OwnerConfirm.tsx';
import { ownerVM } from '../../store/selectors.ts';
import Modal from '../components/Modal.tsx';

const M = { bodyFs: '11px', fieldFs: '12px', pad: '16px 18px 18px', gap: '13px' };

export default function OwnerModals(): JSX.Element | null {
  const s = useQd();
  const v = ownerVM(s);
  if (!v.modal) return null;

  const transfer = v.modal === 'transfer';
  return (
    <Modal
      width={460}
      label={transfer ? 'Transfer ownership' : 'Delete crew'}
      onClose={() => s.closeOwn()}
      header={{
        title: transfer ? 'HAND OVER THE PARTY' : 'DISBAND PARTY',
        note: transfer ? v.crewNameUp : v.crewNameUp + ' · CANNOT BE UNDONE',
      }}
    >
      {transfer ? <TransferBody m={M} /> : <DeleteCrewBody m={M} />}
    </Modal>
  );
}
